import type { Snapshot } from '@/api/v4/snapshot-funnel.api';

export const getStageCountFromSnapshot = (
  snapshot: Snapshot,
  names: string[],
): number =>
  snapshot
    .filter(s => names.includes(s.name))
    .reduce((sum, s) => sum + s.count, 0);
